<template>
  <div id="changeUserInfo">
    <!-- 左侧边栏 -->
    <ul class="changeInfoLeftSideBar" :style="isProjectBarShow?{width:'230px'}:{width:'110px'}">
      <li style="cursor: default;">
        <img
          style="margin-left:42px;width:26px;cursor: pointer;"
          @click="handleProjectSideBarSild"
          src="../../../assets/image/icon_zk@2x.png"
          alt
        />
      </li>
      <li
        v-if="isProjectBarShow"
        @click="sidBarSelect('1')"
        :class="sideBarActive=='1'?'leftSideBarActive':''"
      >
        <img src="../../../assets/image/icon_quanbu@2x.png" alt />
        <span>项目流程</span>
      </li>
      <li
        v-if="isProjectBarShow"
        @click="sidBarSelect('2')"
        :class="sideBarActive=='2'?'leftSideBarActive':''"
      >
        <img src="../../../assets/image/problemHeader.png" alt />
        <span>反馈列表</span>
      </li>
      <li
        v-if="isProjectBarShow"
        @click="sidBarSelect('5')"
        :class="sideBarActive=='5'?'leftSideBarActive':''"
      >
        <img src="../../../assets/image/iconBangzhu.png" alt />
        <span>使用帮助</span>
      </li>
      <!-- 缩小的 -->
      <li v-if="!isProjectBarShow" @click="sidBarSelect('1')" class="smallLi">
        <div class="logoBgc" :class="sideBarActive=='1'?'leftSideBarActiveSmall':''">
          <img src="../../../assets/image/icon_quanbu@2x.png" alt />
        </div>
      </li>
    </ul>
    <!-- 右边主体 -->
    <div
      class="changeUserInfoBox"
      :style="isProjectBarShow?{width: 'calc(100% - 230px)'}:{width: 'calc(100% - 110px)'}"
    >
      <router-view />
    </div>
    <!-- 使用帮助 -->
    <!-- 抽屉 -->
    <!-- <el-drawer
      class="helperDrawer"
      :visible.sync="drawerVis"
      :modal="false"
      :show-close="false"
      size="230px"
      :direction="'ltr'"
      :before-close="handleCloseDrawer"
      @closed="handleClosedDrawer"
    >
      <ul class="optionsContainer">
        <li class="item" v-for="item in helperDrawerOptions" :key="item.id">
          <div
            :class="helperDrawerSlected1==item.id?'itemTitleSlelcted':''"
            class="itemTitle"
            @click="handleSelect1(item)"
          >
            <span>{{item.showName}}</span>
            <img
              class="arrowDown"
              v-if="item.children && item.children.length>0"
              src="../../../assets/image/arrDown.png"
              alt
            />
          </div>
          <div class="itemsBox" v-if="helperDrawerSlected1==item.id">
            <div
              @click="handleSelect2(items)"
              class="items"
              :class="helperDrawerSlected2==items.id?'itemsTitleSlelcted':''"
              v-for="items in item.children"
              :key="items.id"
            >{{items.title}}</div>
          </div>
        </li>
      </ul>
    </el-drawer>-->
    <div class="helpBox" v-if="contentShow"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      isProjectBarShow: true,
      sideBarActive: '1',
      // 使用帮助
      drawerVis: true,
      helperDrawerSlected1: '',
      helperDrawerSlected2: '',
      helperDrawerOptions: [
        {
          label: '登陆与注册',
          id: '1',
          children: [
            { label: '登陆', id: '1-1' },
            { label: '注册', id: '1-2' },
          ],
        },
        {
          label: '项目',
          id: '2',
          children: [],
        },
        {
          label: '财务',
          id: '3',
          children: [],
        },
      ],
      contentShow: false,
    }
  },
  methods: {
    handleProjectSideBarSild() {
      this.isProjectBarShow = !this.isProjectBarShow
    },
    sidBarSelect(val) {
      this.sideBarActive = val
      if (val == '1') {
        if (this.$route.path == '/projectStep/step') return
        this.$router.push({
          path: '/projectStep/step',
        })
      }
      if (val == '2') {
        if (this.$route.path == '/projectStep/problem') return
        this.$router.push({
          path: '/projectStep/problem',
        })
      }
      if (val == '5') {
        // this.drawerVis = true
        if (this.$route.path == '/projectStep/help') return
        this.$router.push({
          path: '/projectStep/help',
        })
      }
    },
    // 使用帮助开始
    // *获取使用帮助列表
    async getHelpList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('type', '1')

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Help/index',
        data: param,
      })
      if (res.code != 200) {
        return this.$message.error(res.datas.msg)
      }
      this.helperDrawerOptions = res.datas.listInfo
      console.log('帮助中心', this.helperDrawerOptions)
    },

    handleCloseDrawer() {
      // this.drawerVis = false
    },
    handleClosedDrawer() {
      // this.contentShow = false
    },
    // 父级
    handleSelect1(item) {
      this.helperDrawerSlected1 = item.id
      if (item.children && item.children.length > 0) return
      // if (item.id != '1') {
      //   this.helperDrawerSlected2 = ''
      // }

      // this.getHelpDetails(item.id)
      this.$router.push({
        path: '/projectStep/help',
        query: {
          id: item.id,
        },
      })
    },
    // 子级
    handleSelect2(item) {
      this.helperDrawerSlected2 = item.id

      // this.getHelpDetails(item.id)

      this.$router.push({
        path: '/projectStep/help',
        query: {
          id: item.id,
        },
      })
    },
    watchrouter() {
      if (this.$route.path == '/projectStep/help') {
        this.sideBarActive = '5'
        this.drawerVis = true
      }
      if (this.$route.path == '/projectStep/step') {
        this.sideBarActive = '1'
      }
    },
    // 使用帮助结束
  },
  watch: {
    $route: 'watchrouter', //路由变化时，执行的方法
  },
  created() {
    if (this.$route.path == '/projectStep/help') {
      this.sideBarActive = '5'
    }
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    // alert(this.member_id)
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    // 获取使用帮助列表
    this.getHelpList()
  },
}
</script>
<style lang="less" scoped>
#changeUserInfo {
  width: 100%;
  height: 92%;
  background-color: #f2f3f4;
  display: flex;
  // 左侧边栏
  .changeInfoLeftSideBar {
    height: 100%;
    background-color: #1c7aca;
    li {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 100%;
      height: 95px;
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      .projectSideBarIcon {
        cursor: pointer;
        font-size: 36px;
        margin-left: 42px;
      }
      img {
        width: 20px;
        margin-left: 52px;
        margin-right: 15px;
      }
    }
    .smallLi {
      display: flex;
      align-items: center;
      // background-color: #1c7aca !important;
      .logoBgc {
        width: 72px;
        height: 72px;
        border-radius: 36px;

        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 19px;
        img {
          width: 25px;
          margin: 0;
        }
      }
    }
    .leftSideBarActiveSmall {
      background-color: #40a0f2;
    }
    .leftSideBarActive {
      background-color: #40a0f2;
      color: #fff;
    }
  }
  // 右主体表单
  .changeUserInfoBox {
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
  }
}
// 帮助说明
/deep/.helperDrawer {
  .el-drawer {
    position: absolute;
    left: 230px;
    // animation: none;
    animation: ltr_2 0.3s 1ms;
    height: 92%;
    top: 8%;
    box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.3);
    overflow-y: auto;
  }
  .el-drawer__header {
    display: none;
  }
  .optionsContainer {
    width: 100%;
    height: 100%;
    .item {
      width: 100%;
    }
    .itemTitle {
      cursor: pointer;
      position: relative;
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #333;
      height: 42px;
      display: flex;
      align-items: center;
      padding-left: 17px;
      width: 100%;
      box-sizing: border-box;
      .arrowDown {
        width: 14px;
        position: absolute;
        right: 20px;
      }
    }
    .itemTitle::before {
      content: '';
      width: 20px;
      height: 20px;
      background-color: #d8d8d8;
      margin-right: 10px;
    }
    .itemsBox {
      animation: ltr-drawer-in 0.3s 1ms;
    }
    .items {
      cursor: pointer;
      display: flex;
      align-items: center;

      height: 42px;
      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      padding-left: 23px;
    }
    .items::before {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #d8d8d8;
      margin-right: 16px;
    }
    .itemTitleSlelcted {
      background: #3a9ef4;
      color: #fff;
    }
    .itemsTitleSlelcted {
      color: #3a9ef4;
    }
    .itemsTitleSlelcted::before {
      background-color: #3a9ef4;
    }
  }
}
.helpBox {
  position: absolute;
  width: calc(100% - 460px);
  background-color: #fff;
  height: 92%;

  top: 8%;
  z-index: 99;
  box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.3);
  right: 0;
  animation: rtl-drawer-in 0.3s 1ms;
  padding: 40px 60px;

  box-sizing: border-box;
  .title {
    margin-bottom: 10px;
    font-size: 22px;
    color: #333;
  }
  .time {
    margin: 20px;
    font: 14px;
    color: #999;
  }
  .content {
    font-size: 12px;
    color: #9e9e9e;
    width: 100%;
  }
}
@keyframes ltr_2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>